import { Toast } from 'cube-ui'
import Request from '@/assets/script/request'
import ENV from './env'

const Http = new Request({
  resSuccessCode: 1,
  devBaseUrl: ENV.interfaceUrl,
  errCallback (msg) {
    Toast.$create({
      txt: msg,
      type: 'error'
    }).show()
  }
})

export default Http


// WEBPACK FOOTER //
// ./src/database/config.js